import { render } from "./DatePager.vue?vue&type=template&id=93f45ff2&ts=true"
import script from "./DatePager.vue?vue&type=script&lang=ts"
export * from "./DatePager.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__